import { render, staticRenderFns } from "./inline-edit-table.vue?vue&type=template&id=15b0fc52&scoped=true&"
import script from "./inline-edit-table.vue?vue&type=script&lang=js&"
export * from "./inline-edit-table.vue?vue&type=script&lang=js&"
import style0 from "./inline-edit-table.vue?vue&type=style&index=0&id=15b0fc52&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15b0fc52",
  null
  
)

export default component.exports